import { GiPartyPopper } from "react-icons/gi"
import { SubformProps } from "."

export const Submitted = ({ formData }: Partial<SubformProps>) => {
  const timeframe = `Please note that this is an estimated timeline and actual processing times may vary.`

  if (![formData.prequalResult, formData.prequalResultCombined].includes('pass')) {
    return <div className="alert alert-info">
      Your application has been received and is pending review. A member of our
      banking team will reach out to you within 5-7 business days to discuss next steps. {timeframe}
    </div>
  }

  return <div>
    <div className="text-center">
      <GiPartyPopper size={100} color="green" />
    </div>

    <div>
      <h4 className="text-center">Congratulations!</h4>
      {formData.envelopes?.length ? <div className="mb-3">
        Your application has been submitted and is approved pending document verification. You
        should receive a Docusign package via email shortly. These documents must be signed to
        complete the application process. After signing, a Loan Officer will contact you within
        5-7 business days to review the application and finalize your loan. {timeframe}
      </div> : <div>
        Your application has been pre-qualified pending document verification. A member of
        our banking team will reach out within 5-7 business days to continue the application
        process. {timeframe}
      </div>}
    </div>
  </div >
}

